import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import moment from "jalali-moment";
import useStore from "../../features/store";
import { checkTransaction } from "../../services/proAnalyse";
import Logo from "../../assets/images/Bodybon-TypeLogo.png";

const Checkout = () => {
  const { paymentId } = useParams();
  const navigate = useNavigate();
  //@ts-ignore
  const { profile } = useStore();

  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState<any>(null);
  const [status, setStatus] = useState<any>(null);
  const [countdown, setCountdown] = useState<number>(5); // Countdown state

  const fetchTransaction = async () => {
    try {
      const response = await checkTransaction(Number(paymentId));

      if (response?.data?.results[0]?.status !== "OnWait") {
        setLoading(false);
        setPaymentData(response?.data?.results[0]);
        setStatus(response?.data?.results[0]?.status);
      } else {
        setStatus("OnWait");
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchTransaction();

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && status === "OnWait") {
        fetchTransaction();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [status]);

  useEffect(() => {
    if (status === "OnWait") {
      fetchTransaction();
    }
  }, [status]);

  // Countdown logic when payment status is 'Paid'
  useEffect(() => {
    if (status === "Paid") {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            // Redirect after countdown reaches 0
            setTimeout(() => {
              navigate(`/additional-information/${paymentData?.test_record}`);
            }, 500); // Adding a small delay before navigation
            return 0;
          }
          return prev - 1;
        });
      }, 1000); // Decrease countdown every second

      return () => clearInterval(timer); // Cleanup the interval
    }
  }, [status, paymentData, navigate]);

  return (
    <div className="flex-1 flex flex-col lg:flex-row lg:items-start justify-between mt-14">
      {loading ? (
        <div className="w-full min-h-[60vh] flex flex-col items-center justify-center">
          <h1 className="font-rokh font-[900] text-2xl lg:text-3xl text-center">
            در حال بررسی وضعیت پرداخت
          </h1>
        </div>
      ) : paymentData?.status === "Canceled" ? (
        <div className="w-full min-h-[60vh] flex flex-col items-center justify-center">
          <h1 className="font-rokh font-[900] text-2xl lg:text-3xl text-center">
            پرداخت شما لغو شد.
          </h1>
          <p className="font-rokh font-[700]">
            از طریق لینک زیر می‌تونی دوباره آزمایشت رو بارگذاری کنی
          </p>
          <Link
            to="/test-registration"
            className="btn text-lg py-2 min-w-[200px] text-white bg-pr_primary hover:bg-pr_blue_dark mt-8"
          >
            تلاش مجدد
          </Link>
        </div>
      ) : (
        <>
          <div className="flex-[2] flex flex-col items-center lg:items-start mb-10 lg:mb-0">
            <h1 className="font-rokh font-[900] text-2xl lg:text-3xl">
              پرداخت شما با موفقیت انجام شد.
            </h1>

            {status === "Paid" && (
              <p className="mt-1 font-bold">
                <span className="countdown">
                  <span
                    style={{
                      //@ts-ignore
                      "--value": `${countdown}`,
                    }}
                  ></span>
                </span>
                ثانیه تا ادامه مسیر تحلیل آزمایش پیشرفته
              </p>
            )}

            <Link
              to={`/additional-information/${paymentData?.test_record}`}
              className="btn text-lg py-2 min-w-[200px] text-white bg-pr_primary hover:bg-pr_blue_dark mt-8"
            >
              ادامه
            </Link>
          </div>

          <div className="flex-1 h-full border rounded-xl p-5 mb-10">
            <h2 className="font-rokh font-[700] text-xl border-b pb-2 mb-10 text-center">
              فاکتور سفارش
            </h2>

            <div className="flex items-center justify-between mb-5">
              <h6>سفارش‌دهنده:</h6>
              <p className="font-bold">
                {profile?.user?.first_name} {profile?.user?.last_name}
              </p>
            </div>

            <div className="flex items-center justify-between mb-5">
              <h6>پرداخت بابت:</h6>
              <p className="font-bold">تحلیل پیشرفته آزمایش</p>
            </div>

            <div className="flex items-center justify-between mb-5">
              <h6>تاریخ پرداخت:</h6>
              <p className="font-bold">
                {moment
                  .from(paymentData?.update_at_jalali, "fa", "DD-MM-YYYY")
                  .locale("fa")
                  .format("jYYYY/jMM/jDD")}
              </p>
            </div>

            <div className="flex items-center justify-between mb-5">
              <h6>شماره سفارش:</h6>
              <p className="font-bold">{paymentData?.station_code}</p>
            </div>

            <div className="flex items-center justify-between mb-5">
              <h6> هزینه:</h6>
              <p className="font-bold">
                {paymentData?.amount.toLocaleString()} تومان
              </p>
            </div>

            <div className="flex items-center justify-between mt-20 border-t pt-5">
              <img src={Logo} alt="بادی‌بان" className="w-24 lg:w-28" />
              <a href="mailto:support@bodybon.info">support@bodybon.info</a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Checkout;
